<script setup lang="ts">
import AvailableIcons from '@/interfaces/AvailableIcons';
import ConnxIcon from './ConnxIcon.vue';

interface Props {
  title?: string;
  type?: 'default' | 'info' | 'success' | 'warning';
}

const props = withDefaults(defineProps<Props>(), {
  type: 'default'
});

const classMap = new Map([
  ['default', 'tw-bg-connx-grey-tint-85'],
  ['info', 'tw-bg-connx-info'],
  ['success', 'tw-bg-connx-success'],
  ['warning', 'tw-bg-connx-warning'],
  ['danger', 'tw-bg-connx-danger'],
]);

const iconMap = new Map([
  ['info', 'far fa-info-circle'],
  ['success', 'far fa-check-circle'],
  ['warning', 'far fa-exclamation-circle'],
  ['danger', 'far fa-times-circle'],
])

</script>

<template>
  <article
    class="tw-p-4 tw-rounded-md tw-w-full tw-max-w-full tw-flex-grow-0 tw-shadow"
    :class="classMap.get(type)"
  >
    <div class="tw-flex">
      <div v-if="iconMap.has(type)">
        <connx-icon
          class="tw-text-connx-white tw-mr-6 tw-w-8 tw-h-auto"
          :name="iconMap.get(type) as AvailableIcons"
        ></connx-icon>
      </div>
      <div>
        <header v-if="title">
          <h3>{{ title }}</h3>
        </header>
        <section>
          <slot></slot>
        </section>
      </div>
    </div>
  </article>
</template>
